import styled, { css } from 'styled-components';
import { neutralWhite } from '../../themes/colors';
import { Icon } from '../../icon';

export const DropdownContainer = styled.div`
	position: relative;
`;

export const StyledSelectInput = styled.div<{
	$disabled?: boolean, 
	$active?: boolean, 
	$size?: 'default' | 'small', 
	$hasError?: boolean,
	$hasContent?: boolean
}>`
	font-family: ${props => props.theme.font};

	display: flex;
	flex-direction: row;
	white-space: nowrap;
	background: ${neutralWhite};
	min-height: ${props => props.$size === 'small' 
		? props.theme.form.multiSelectDropdown.size.small.height 
		: props.theme.form.multiSelectDropdown.size.default.height}px;
	padding: ${props => props.$size === 'small' 
		? props.theme.form.multiSelectDropdown.size.small.padding 
		: props.theme.form.multiSelectDropdown.size.default.padding};
	font-size: ${props => props.$size === 'small' 
		? props.theme.form.multiSelectDropdown.size.small.fontSize 
		: props.theme.form.multiSelectDropdown.size.default.fontSize}px;
	line-height: 1;
	position: relative;
	cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
	border: ${props => props.theme.form.border.width}px 
		solid ${props => props.theme.form.input.border};
	border-radius: ${props => props.theme.form.border.radius}px;
	box-sizing: border-box;

	-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
	-o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
	transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;	

	${({ $hasError, theme }) => $hasError && css`
		border: ${theme.form.border.width}px solid ${theme.form.input.error.border};
		box-shadow: ${theme.form.input.error.shadow};
	`}

	:focus {
		border-color: ${props => props.theme.form.input.focus.border};
		box-shadow: ${props => props.theme.form.input.focus.shadow};
		outline: 0;
	}
	${props => props.$active && !props.$hasError && css`
		border-color: ${props.theme.form.input.focus.border};
		box-shadow: ${props.theme.form.input.focus.shadow};

		${StyledChevron} {
			color: ${props.theme.form.input.accentColor};
		}
	`}

	::placeholder {
		color: ${props => props.theme.form.input.placeholderColor};
	}

	${({ $disabled, theme }) => $disabled && css`
		background: ${theme.form.disabled.background};
		opacity: ${theme.form.disabled.opacity};
	`}
`;

export const StyledChevron = styled(Icon)`
	flex: 0 0 auto;
	color: ${props => props.theme.form.dropdown.chevron.color};
	margin-left: 4px;
	align-self: center;
`;

export const StyledSelectionItems = styled.div`
	display: flex;
	overflow: auto;
	position: relative;
	flex: 1 auto;
	flex-wrap: wrap;
	gap: 4px;
	align-items: center;
	line-height: 1;
`;

export const StyledPlaceholder = styled.span<{$size?: 'default' | 'small'}>`
	color: ${props => props.theme.form.input.placeholderColor};;
	text-overflow: ellipsis;
	overflow: hidden;
	align-items: center;
	white-space: nowrap;
	font-size: ${props => props.$size === 'small' 
		? props.theme.form.multiSelectDropdown.size.small.fontSize 
		: props.theme.form.multiSelectDropdown.size.default.fontSize}px;
	align-self: center;
	flex: 1 1 auto;
`;

export const MultiSelectMenuRoot = styled.div`
	border-radius: 2px;
	box-shadow: ${props => props.theme.form.dropdown.menu.shadow};
	z-index: 45;
`;

export const MultiSelectMenuOverflow = styled.div`
	font-family: "Red Hat Display", sans-serif;
	box-sizing: border-box;
	background: ${neutralWhite};
	display: flex;
	flex-direction: column;
	max-height: 400px;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 8px 15px;
	border: none;
	border-bottom: 1px solid ${props => props.theme.form.input.border};
	font-family: ${props => props.theme.font};
	font-size: 14px;
	outline: none;
	color: ${props => props.theme.form.input.color};
	box-sizing: border-box;
	
	&::placeholder {
		color: ${props => props.theme.form.input.placeholderColor};
	}
`;

